import { useState } from "react";

export default function ProfileForm({ onComplete }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    dob: "",
    gender: "",
    preferredName: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { firstName, lastName, email, dob } = formData;
    if (!firstName || !lastName || !email || !dob) {
      alert("Please fill out all required fields!");
      return;
    }
    onComplete(formData); // send data up to parent
  };

  return (

    <form onSubmit={handleSubmit} className="flex flex-col gap-4 w-full max-w-md mx-auto p-4 rounded-lg shadow-md">
      <h1 className="text-xl font-bold text-center text-white">Profile Information</h1>

      <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required className="p-2 border rounded w-full" />
      <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required className="p-2 border rounded w-full" />
      <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required className="p-2 border rounded w-full" />

      <input
        type="text"
        name="dob"
        placeholder="Date of Birth"
        value={formData.dob}
        onChange={handleChange}
        onFocus={(e) => (e.target.type = "date")}
        onBlur={(e) => { if (!e.target.value) e.target.type = "text"; }}
        className="p-2 border rounded w-full"
      />
      <p className="optional text-center">
        Optional
      </p>
      <select id="gender" name="gender" value={formData.gender || ""} onChange={handleChange} className="p-2 border rounded w-full bg-white text-black">
        <option value="">Select Gender</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
        <option value="Other">Other</option>
        <option value="Prefer not to say">Prefer not to say</option>
      </select>

      <input type="text" name="preferredName" placeholder="Preferred Name" value={formData.preferredName} onChange={handleChange} className="p-2 border rounded w-full" />

      <button type="submit" className="p-2 border rounded w-full">Next</button>
    </form>

  );
}
